module.exports = __webpack_public_path__ + "static/media/blog_img2.4564cfd5.png";